import { render, staticRenderFns } from "./TrunkPanelBoardShow.vue?vue&type=template&id=0a6726e8&"
import script from "./TrunkPanelBoardShow.vue?vue&type=script&lang=js&"
export * from "./TrunkPanelBoardShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports